// TODO: update from new BaseView

import BaseView from '../../../../js/base-view';

const ATTR_ERROR = 'data-error';
const ATTR_COND_NAME = 'data-cond-name';
const ATTR_COND_VALUE = 'data-cond-value';

const CLASS_DISABLED = 'is-disabled';

export default class BaseInput extends BaseView {
	init(selector_field = 'input') {
		this.refs = {
			field: this.el.querySelector(selector_field),
		};

		this.props = {
			isConditinal: false,
			name: this.refs.field.name,
		};

		this.state = {
			isErroneous: false,
		};

		this.setIsConditional();
		this.bindEvents();
	}

	setIsConditional() {
		this.props.isConditinal = (
			this.el.hasAttribute(ATTR_COND_NAME) &&
				this.el.hasAttribute(ATTR_COND_VALUE)
		);

		if (this.props.isConditinal) {
			this.props.condName = this.el.getAttribute(ATTR_COND_NAME);
			this.props.condValues = this.el.getAttribute(ATTR_COND_VALUE).split(',');
			this.toggleDisabled(true);
		}
	}

	bindEvents() {}

	getName() {
		return this.props.name;
	}

	checkCondition(name, value) {
		// Bail early
		if (! this.props.isConditinal) {
			return false;
		}
		if (name === this.getName()) {
			return false;
		}
		if (this.props.condName !== name) {
			return false;
		}

		// Check the condition
		let newIsDisabled = true;
		if (Array.isArray(value)) {
			newIsDisabled = ! this.props.condValues.filter((v) => value.indexOf(v) > -1).length;
		}
		else {
			newIsDisabled = ! (this.props.condValues.indexOf(value) > -1);
		}

		// Bail if condition didn't change
		if (this.state.isDisabled === newIsDisabled) {
			return false;
		}

		// Condition changed, update DOM + state
		this.toggleDisabled(newIsDisabled);
		return true;
	}

	setError(errorMessage = '') {
		this.state.isErroneous = true;
		this.el.setAttribute(ATTR_ERROR, errorMessage);
	}

	resetError() {
		this.state.isErroneous = false;
		this.el.removeAttribute(ATTR_ERROR);
	}

	toggleDisabled(isDisabled) {
		this.state.isDisabled = isDisabled;
		this.el.classList[ (isDisabled ? 'add' : 'remove') ](CLASS_DISABLED);

		if (isDisabled) {
			this.disable();
		}
		else {
			this.enable();
		}
	}

	checkValidity() {
		if (this.refs.field.checkValidity()) {
			this.resetError();
			return true;
		}

		this.setError(this.refs.field.validationMessage);
		return false;
	}

	focus() {
		this.refs.field.focus();
	}

	disable() {
		this.refs.field.setAttribute('disabled', true);
	}

	enable() {
		// Do not enable field if field is condition & should still be hidden
		if (this.props.isConditinal && this.state.isDisabled) {
			return;
		}
		this.refs.field.removeAttribute('disabled');
	}

	reset() {
		this.resetError();

		if (this.props.isConditinal) {
			this.toggleDisabled(true);
		}
	}
}
